<template>
  <div class="pageContent alipayRedPacket">
    <LoadingModal />
    <div class="header-section">
      <div class="points-info">
        <span class="label">积分总额：</span>
        <span class="points-value">{{ totalPoints }}</span>
        <span class="view-detail" @click="$push({ name: 'PointsAccounts' })">查看详情</span>
      </div>
      <button class="exchange-btn" @click="goOrderList">兑换记录</button>
    </div>
    <div v-if="!$store.state.pageLoading">
      <Top :title="name" :message="tips" v-if="tips != ''" />
      <VTitle val="支付方式" :showLine="false" />
      <div class="balancePay coupons van-cell" style="border-radius: 10px;" v-show="couponsBalanceList.length == 0">
        暂无可用卡券
      </div>
      <PayWay
        ref="payway"
        :placeholder="''"
        :sellData="sellData"
        :tips="tips"
        :discount="discount"
        :isWechatPay="wechatpay"
        :type="8"
        :params="params"
        :isSend="isSend"
        :balance="balance"
        :couponsId="couponsId"
        :couponsName="couponsName"
        :isMember="isMember"
        :vip_discount="vip_discount"
        :discount_coupons="discount_coupons"
        :can_use_power="can_use_power"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        :ident="ident"
        @onComfirm="payHandle"
      />
      <VTitle :val="'兑换积分'"  :showLine="false" />
      <div class="pageBigRadius pageCarServeShadow" style="position: relative;">
        <van-field
          v-model="points"
          class="pageBigRadius input"
          placeholder="请输入积分"
          :error-message="pointsErrorMsg"
          @input="inputPoints"
        >
          <template #right-icon>
            <span class="tips-text" v-show="points > 0">点击输入框可修改兑换数量</span>
          </template>
        </van-field>
        <div v-if="points && couponsBalanceChecked.length > 0" class="required-amount">
          售价：{{ Number(requiredAmount.toFixed(2)) }} (折扣：{{ Number((couponsWechatRedpacketRebate * 100).toFixed(2)) }}%)
        </div>
      </div>
      <!-- <VTitle val="邮箱" :showLine="false" />
      <div class="pageBigRadius pageCarServeShadow">
        <van-field
          v-model="email"
          class="pageBigRadius input"
          placeholder="请输入邮箱"
          :error-message="emailErrorMsg"
          @input="inputEmail"
          type="text"
        />
      </div> -->
      <VTitle val="支付宝账号" :showLine="false" />
      <div class="pageBigRadius pageCarServeShadow">
        <van-field
          v-model="account"
          class="pageBigRadius input"
          placeholder="请输入支付宝账号"
          :error-message="accountErrorMsg"
          maxlength="11"
          @input="input"
          type="number"
          ref="accounts"
          id="accounts"
        />
      </div>

      <div class="agreement" style="margin-bottom: 5px;">
        <van-checkbox
          v-model="registerAndInfoChecked"
          shape="square"
          icon-size="14px"
          label-disabled
          >已阅读并同意
          <div class="agreement-content">
            <span class="text" @click="agreementClickHandle()"
              >《用户注册协议及用户信息使用须知》</span
            >
          </div>
        </van-checkbox>
      </div>
      <van-button
        class="pageDefaultRadius pageBannarShadow pageFontWeight clickPay"
        color="var(--depYelColor)"
        :disabled="disabeledButton()"
        @click="payHandle"
        block
        id="paybtn"
      >
        <span>立即提交</span>
      </van-button>

      <Tips>
        <div slot="content">
          <ul
            style="
              list-style: disc;
              margin-left: 15px;
            "
          >
            <li style="list-style: disc">
              <b>稳易云积分产品说明：</b>
              <p>- “稳易云积分”可用于支付宝支付场景消费抵扣使用；</p>
              <p>- 使用支付宝扫码支付或出示付款码均可抵扣；</p>
              <p>- 付款方式请选择因公付（麦的好 Y）；</p>
              <p>- 单日消耗最大支持 999 元；</p>
              <p>- 如有疑问请联系客服；</p>
            </li>
          </ul>
        </div>
      </Tips>
    </div>
    <RegisterAndInfo ref="registerAndInfo2"></RegisterAndInfo>
  </div>
</template>

<script>
import { alipayPointsApi } from "api/onLine";
import { getPoiontsAccountByCurrentUserApi } from '@/api/user'
import RegisterAndInfo from "../../agreement/user/registerAndInfo.vue";
import { Dialog } from "vant";

export default {
  props: {
    type: String,
    name: String,
    cid: Number,
    balance: Number,
    couponsId: String,
    couponsName: String,
    couponsDeduct: Number,
    isMember: Boolean,
    ident: String,
    mouldId: String,
    couponsBalanceList: {
      type: Array,
      default: () => [],
    }
  },
  components: {
    RegisterAndInfo,
  },
  data() {
    return {
      appimg: require("assets/sy.png"),
      points: "",
      pointsErrorMsg: "",
      couponsWechatRedpacketRebate: 1,
      requiredAmount: 0,
      sellData: { sell_price: -1 },
      tips: "",
      describe: "",
      discount: 0,
      index: 0,
      wechatpay: false,
      account: this.$getItem("userModel").userPhone,
      params: { productId: "" },
      sms: "",
      isSend: true,
      data: {},
      vip_discount: 0,
      discount_coupons: [],
      can_use_power: false,
      accountErrorMsg: "",
      isValid: false,
      registerAndInfoChecked: true,
      couponsBalanceChecked: [],
      totalPoints: 0,
      email: "",
      emailErrorMsg: "",
      emailReg: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    };
  },
  created() {
    this.$store.commit("setPageLoading", false);
  },
  watch: {
    "$parent.couponsBalanceChecked": {
      handler() {
        this.couponsBalanceChecked = this.$parent.couponsBalanceChecked;
        if(this.couponsBalanceChecked.length > 0){
          let sum = 0
          this.couponsBalanceChecked.forEach((element) => {
            sum += element.couponsBalance * element.couponsWechatRedpacketRebate
          });
          this.points = Number(sum.toFixed(2))
          this.sellData = {sell_price: this.points};
          this.changePoints()
        }
        if(this.couponsBalanceChecked.length == 0){
          this.points = 0
          this.sellData = {sell_price: -1};
          this.changePoints()
        }
      },
      deep: true
    },
  },
  mounted() {
    setTimeout(() => {
      if(this.couponsBalanceList.length > 0){
        const selectedCoupon = this.couponsBalanceList[0];
        this.sellData = { sell_price: selectedCoupon.couponsBalance};
        this.$parent.couponsBalanceChecked = [selectedCoupon]
      }
    }, 800);
    this.fetchAccounts()
  },
  methods: {
    inputEmail(value) {
      if ('' == value || null == value) {
        this.emailErrorMsg = "请输入邮箱";
        return
      }
      if(!this.emailReg.test(this.email)) {
        this.emailErrorMsg = "请输入正确的邮箱格式";
        return
      }
      this.emailErrorMsg = "";
    },
    async fetchAccounts() {
      const res = await getPoiontsAccountByCurrentUserApi()
      let accounts = res.data ?? []
      let total = accounts.reduce((sum, a) => sum + a.balance, 0)
      this.totalPoints = Number(total.toFixed(2))
    },
    disabeledButton() {
      if(this.points == 0) return true;
      if(this.couponsBalanceChecked.length == 0) return true;
      if(this.account == "" || this.account == null) return true;
      if(this.registerAndInfoChecked == false) return true;
      // if(this.email == "" || this.email == null) return true;
      // if(!this.emailReg.test(this.email)) return true;
      return false
    },
    agreementClickHandle() {
      this.$refs["registerAndInfo2"].show = true;
    },
    goOrderList(){
      this.$push({
        path: "/orders",
        query: { type: "-1" },
      });
    },
    changePoints() {
      const selectedCoupon = this.couponsBalanceList[0];
      if (selectedCoupon && selectedCoupon.couponsWechatRedpacketRebate) {
        this.couponsWechatRedpacketRebate = selectedCoupon.couponsWechatRedpacketRebate;
      }
      const numValue = parseFloat(this.points);
      if (isNaN(numValue) || numValue <= 0 || this.couponsWechatRedpacketRebate <= 0) {
        this.requiredAmount = 0;
      } else {
        this.requiredAmount = numValue / this.couponsWechatRedpacketRebate;
      }
    },
    inputPoints(value) {
      if(this.couponsBalanceChecked.length == 0){
        this.pointsErrorMsg = "请先选择卡券";
        this.points = undefined
        return;
      }
      const numValue = value
        .replace(/。/g, '.')
        .replace(/[^0-9.]/g, '')
        .replace(/\.{2,}/g, '.')
        .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
      let pointsStr = numValue;
      if (isNaN(numValue) || numValue <= 0) {
        this.pointsErrorMsg = "请输入有效数字";
        this.sellData = {
          sell_price: -1,
        };
        let that = this.$parent;
        that.couponsDeduct = 0;
      } else {
        let sum = this.couponsBalanceChecked.reduce((acc, cur) => acc + cur.couponsBalance * cur.couponsWechatRedpacketRebate, 0)
        this.points = this.points > sum ? sum : pointsStr
        this.pointsErrorMsg = "";
        this.sellData = { sell_price: this.points };
      }
      this.changePoints()
      if(this.requiredAmount > 0){
        let sum = this.couponsBalanceChecked.reduce((acc, cur) => acc + cur.couponsBalance, 0)
        let that = this.$parent;
        that.couponsDeduct = this.requiredAmount > sum ? sum : this.requiredAmount
      }
    },
    input(value) {
      if (null == value) {
        this.accountErrorMsg = "请输入支付宝账号";
      } else {
        this.accountErrorMsg = "";
      }
      this.params.account = this.account;
    },
    dialogHandle(title, message){
      return Dialog.confirm({
        title: title,
        message: message,
        messageType: 'html',
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        width: '85%',
      }).then(() => true).catch(() => false);
    },
    async payHandle() {
      if (!this.registerAndInfoChecked) {
        this.$error("请先阅读并勾选同意协议！");
        return false;
      }
      let content = `
        <div style="text-align: center; padding: 15px 15px 0;">
          <div style="font-size: 24px; font-weight: bold; color: #e23636; margin-bottom: 4px;">${this.account}</div>
          <div style="font-size: 14px; color: #e23636; margin-bottom: 12px;">请再次确认需要兑换的支付宝账号</div>
          <div style="background-color: #fff5f5; border-radius: 8px; padding: 10px; text-align: left; font-size: 11px; color: #666; line-height: 1.5;">
            <p style="margin: 0 0 4px 0;">使用：支付宝支付方式选择"因公付（麦的好Y）"即可用于支付宝消费场景抵扣；</p>
            <p>查询：兑换成功后可在当前页面查看余额及消费记录，如有疑问请联系客服；</p>
          </div>
        </div>
      `
      let res = await this.dialogHandle('支付宝账号确认', content)
      if(!res) return
      
      let params = {
        amount: this.points,
        email: this.email,
        account: this.account,
        couponId: this.couponsBalanceChecked.map((item) => item.couponsId),
      }
      this.$loading("订单处理中，请稍后...");
      let {status, message} = await alipayPointsApi(params)
      this.$clear();
      if (status == 200) {
        this.$successSync("下单成功", () => {
          this.$push({
            path: "/orders",
            query: { type: "-1" },
          });
        });
      } else {
        this.$error(message);
      }
    },
  },
};
</script>

<style scoped lang="less">
.alipayRedPacket {
  /deep/ .van-field__control {
    color: #ff3300;
    font-size: 20px;
    font-weight: 900;
  }
  .required-amount {
    padding: 10px 15px;
    color: #666;
    font-size: 14px;
    background-color: #e4e4e4;
    border-radius: 4px;
    margin-top: 10px;
  }
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: linear-gradient(135deg, #34bfe8 0%, #0a60ff 100%);
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(238, 90, 90, 0.3);
}

.points-info {
  display: flex;
  align-items: baseline;
  gap: clamp(4px, 2.5vw, 8px);
}

.label {
  color: rgba(255, 255, 255, 0.9);
  font-size: clamp(13px, 4vw, 15px);
  font-weight: 500;
}

.points-value {
  color: #ffffff;
  font-size: clamp(22px, 7vw, 28px);
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.view-detail {
  color: rgba(255, 255, 255, 0.85);
  font-size: clamp(13px, 4vw, 15px);
  padding-bottom: 2px;
  border-bottom: 1px dashed rgba(255, 255, 255, 0.6);
  cursor: pointer;
  transition: color 0.2s;
  
  &:hover {
    color: #ffffff;
  }
}

.exchange-btn {
  padding: clamp(6px, 2vw, 10px) clamp(14px, 4.5vw, 22px);
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  color: #ffffff;
  font-size: clamp(12px, 4vw, 15px);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }
}

.agreement {
  font-size: 15px;
  margin-top: 15px;
  font-size: var(--smallFont);
  /deep/.van-checkbox__label {
    line-height: normal;
    color: #999;
  }
  .agreement-content {
    display: inline;
    .text {
      font-weight: 700;
    }
  }
  .van-checkbox {
    height: auto;
  }
}

.tips-text {
  font-size: 12px;
  color: #999999;
  padding-right: 5px;
}

ul p{
  color: rgb(0, 0, 0);
  opacity: 0.53;
}
ul b{
  color: rgb(0, 0, 0);
  opacity: 0.70;
}

@media screen and (min-width: 300px) and (max-width: 390px) {
  .label{
    font-size: clamp(12px, 3.5vw, 16px);
  }
  .view-detail{
    font-size: clamp(12px, 3.5vw, 16px);
  }
  .points-value {
    font-size: clamp(16px, 5vw, 24px);
  }
  .exchange-btn{
    padding: clamp(4px, 1vw, 10px) clamp(12px, 3.5vw, 22px);
    font-size: clamp(12px, 4vw, 15px);
  }
  .header-section{
    padding: 10px 14px;
  }
}
</style>
